import React from 'react';
import { Form } from 'react-bootstrap';

interface EntriesPerPageProps {
    value: number;
    onChange: (value: number) => void;
    options?: number[];
}

const EntriesPerPage: React.FC<EntriesPerPageProps> = ({
    value,
    onChange,
    options = [5, 10, 20, 50],
}) => {
    return (
        <div className="d-flex align-items-center gap-2">
            <Form.Label className="mb-0" style={{ color: 'var(--text-primary)' }}>Show</Form.Label>
            <Form.Select
                size="sm"
                style={{
                    width: '75px',
                    backgroundColor: 'var(--bg-primary)',
                    borderColor: 'var(--card-border)',
                    color: 'var(--text-primary)',
                }}
                value={value}
                onChange={(e) => onChange(Number(e.target.value))}
            >
                {options.map((option) => (
                    <option key={option} value={option}>
                        {option}
                    </option>
                ))}
            </Form.Select>
            <span className="mb-0" style={{ color: 'var(--text-primary)' }}>entries</span>
        </div>
    );
};

export default EntriesPerPage;
